// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "a260ef75",
    "hash": "a260ef75",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "a260ef75",
    "semverString": null,
    "timestamp": 1781643825029,
    "dateStr": "Tue Jun 16 2026 21:03:45 GMT+0000 (Coordinated Universal Time)"
};
/* tslint:enable */
